import ShaderCanvas from "../components/ShaderCanvas";
import React, { useState } from "react";

const fragShader = `
#ifdef GL_ES
precision mediump float;
#endif

uniform vec2 u_resolution;

float plot(vec2 st) {    
    return smoothstep(0.01, 0.0, abs(st.y - st.x));
}

void main() {
    vec2 st = gl_FragCoord.xy/u_resolution;

    float y = st.x;

    vec3 color = vec3(y);

    float pct = plot(st);
    color = (1.0-pct)*color+pct*vec3(1.0,0.0,0.0);

    gl_FragColor = vec4(color,1.0);
}
`;

export default () => {
  const [live, setLive] = useState({ time: 0, resolution: [0,0], mouse: [0,0], mouseNorm: [0,0] });

  return(
    <div style = { { position: "relative", display: "flex", justifyContent: "center", gap : "16px" } }>
        <ShaderCanvas fragShader={fragShader} onFrame={(vals) => setLive(vals)} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <pre>
            {(() => {
              let src = fragShader;
              src = src.replace(/uniform\s+float\s+u_time\s*;/, `uniform float u_time; // ${live.time.toFixed(1)}`);
              src = src.replace(/uniform\s+vec2\s+u_resolution\s*;/, `uniform vec2 u_resolution; // ${live.resolution[0]} x ${live.resolution[1]}`);
              src = src.replace(/uniform\s+vec2\s+u_mouse\s*;/, `uniform vec2 u_mouse; // ${live.mouseNorm[0].toFixed(1)} , ${live.mouseNorm[1].toFixed(1)}`);
              
              src = src.replace(
                /float\s+y\s*=\s*pow\(st\.x,\s*5\.0\s*\+\s*sin\(u_time\)\s*\*\s*4\.0\)\s*;/,
                `float y = pow(st.x, 5.0 + sin(u_time) * 4.0); // ${(5.0 + Math.sin(live.time) * 4.0).toFixed(1) }`
              );

              return src;
            })()}
          </pre>
        </div>
    </div>
  );
}